module.exports = __webpack_public_path__ + "img/welcome-login.b589e0a4.svg";